import { makeStyles } from 'tss-react/mui';

export default makeStyles<void, 'text' | 'icon'>()({
    menuItem: {
        height: 40,
        color: '#232323',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 8,
        '&:hover': {
            background: '#F8F8F8'
        }
    },
    active: {
        background: '#F8F8F8'
    },
    text: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        letterSpacing: '-0.28px'
    },
    textAdaptive: {
        transition: 'all 0.2s linear',
        '@media (max-width: 1024px)': {
            width: 0,
            display: 'none'
        },
        '@media (max-width: 460px)': {
            width: 'initial',
            display: 'block'
        }
    },
    icon: {
        margin: 12
    },
    expanded: {},
    link: {
        textDecoration: 'none'
    },
    tooltip: {
        padding: 12,
        borderRadius: 8,
        background: '#2D2D2D',
        color: '#FFF',
        textAlign: 'center',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.26px'
    }
});
